import { Button, Col, Form, Input, Modal, Row, Select, Space, Switch } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ModalCreatedCabinet({
  form,
  openModal,
  onCancel,
  selected,
  handleSubmit,
  loading,
}) {
  const { t } = useTranslation()

  useEffect(() => {
    if (selected) {
      form.setFieldsValue({
        code: selected.code,
        name: selected.name,
        shop_code: selected.shop_code,
        address: selected.address,
      });
    }
  }, [selected, form]);

  return (
    <Modal
      title={!selected ? t('addCabinet') : t('updateCabinet')}
      centered
      open={openModal}
      footer={null}
      onCancel={onCancel}
      width={768}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="code"
          label={t('cabinetCode')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="name"
          label={t('cabinetName')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="address"
          label={t('address')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="shop_code"
          label={t('shopCode')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Row gutter={16}>
          <Col span={4} offset={8}>
            <Form.Item>
              <Button style={{ width: "100%" }} htmlType="submit" loading={loading}>
                Ok
              </Button>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Button style={{ width: "100%" }} onClick={onCancel} loading={loading}>
              {t('cancel')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
